import { Dialog, Button, Typography, Box, Snackbar } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { BaseUsersListDialogStyle as styles } from "./BaseUsersListDialogStyle";
import { UserListItem } from "./Table/UserListTable";

type Props = {
  open: boolean;
  onClose: () => void;
  userInfo: UserListItem[];
};

const BaseUsersListDialog: React.FC<Props> = ({ open, userInfo, onClose }) => {
  // ユーザー3列グループ化
  const groupUsers = (users: UserListItem[], groupSize: number) => {
    const groups = [];
    for (let i = 0; i < users.length; i += groupSize) {
      groups.push(users.slice(i, i + groupSize));
    }
    return groups;
  };

  const groupedUsers = groupUsers(userInfo, 3);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Dialog
        open={open}
        onClose={() => {
          onClose();
        }}
        disableEnforceFocus
        maxWidth={false}
        fullWidth={false}
        PaperProps={{
          sx: {
            display: "flex",
            width: "1200px",
            height: "600px",
            maxWidth: "none",
            maxHeight: "none",
            overflowY: "auto",
          },
        }}
      >
        <Box sx={styles.header}>
          <Typography sx={styles.headerText}>拠点ユーザー一覧</Typography>
          <Button
            onClick={() => {
              onClose();
            }}
            sx={styles.closeButton}
          >
            ×
          </Button>
        </Box>
        <Box sx={styles.formArea}>
          {/* ユーザー一覧 */}
          <Box sx={{ mt: 2 }}>
            {groupedUsers.map((group, rowIdx) => (
              <Box
                key={rowIdx}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "16px",
                  mb: "8px",
                }}
              >
                {group.map((user) => (
                  <Box
                    key={user.id}
                    sx={{
                      width: "200px",
                      // border: "1px solid #ccc",
                      borderRadius: "4px",
                      p: "4px",
                      textAlign: "center",
                    }}
                  >
                    {`${user.userNumber ?? ""}_${user.lastName ?? ""}${
                      user.firstName ?? ""
                    }`}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
      </Dialog>
    </LocalizationProvider>
  );
};

export default BaseUsersListDialog;
